import moment from 'moment'

const formatDateTime = (date?: string | Date) =>
  moment(date).format('YYYY.MM.DD HH:mm')

const formatDate = (date?: string | Date) => moment(date).format('YYYY.MM.DD')

const formatTime = (date?: string | Date) => moment(date).format('HH:mm')

export { formatDate, formatDateTime, formatTime }
